import { useCallback } from "react";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../context";

export const useUpdateButton = () => {
	const { viewModel, onUpdate } = useAccommodationHotelPolicyFormModelContext();

	const handleClick = useCallback(() => {
		onUpdate();
	}, [onUpdate]);

	const isValid = !viewModel.hasError && viewModel.isDirty;

	return {
		isValid,
		handleClick,
	};
};
